<template>
    <div class="support_chat">
        <div class="row">
            <div class="support_box_inner">
                <div class="chat_messenger_box">
                    <div class="chat_messenger_header" style="background-color: #1e1e1f; color: rgb(255, 255, 255);">
                        <h4 class="chat_messenger_prompt">Admin Support</h4> <span class="chat_close_icon"><i
                                class="fa fa-window-close" aria-hidden="true"
                                @click="handleSupportChatClosedMethod"></i></span>
                    </div>
                    <div class="chat_messenger_content">
                        <div class="messenger_messages_box" id="chatbot_scroll">
                            <ul class="messenger_messages_list" id="messages">
                                <li v-for="item in messagesList"
                                    :class="item.sender_info.id == selfUserId ? 'sent' : 'received'" :key="item.id"
                                    :id="'chatMessageId' + item.id">
                                    <div class="chat_in_msg_box_wrp">
                                        <template v-if="item.delete_for_everyone">
                                            <span style="color: #4c4c4c;"><i class="fa fa-ban" aria-hidden="true"></i>
                                                This message was deleted</span>
                                        </template>
                                        <template v-else>
                                            <template v-if="item.forwarded">
                                                <span class="forwarded_msg_text">
                                                    <i class="fa fa-share" aria-hidden="true"></i>
                                                    <span>Forwarded</span>
                                                </span>
                                                <template v-if="item.forwarded_from">
                                                    <span class="msg_in_file" v-if="item.forwarded_from.file">
                                                        <span v-if="isImageFile(item.forwarded_from.file)"
                                                            class="msg_img_render_in_chat">
                                                            <a :href="item.forwarded_from.file" target="_new"
                                                                v-on:click.prevent="fileOpenNewTab(item.forwarded_from.file)">
                                                                <img :src="item.forwarded_from.file" alt=""
                                                                    class="img-fluid">
                                                            </a>
                                                        </span>
                                                        <span class="msg_file_render_in_chat" v-else>
                                                            <a :href="item.forwarded_from.file" target="_new"
                                                                v-on:click.prevent="fileOpenNewTab(item.forwarded_from.file)">
                                                                <img :src="checkFileExtensionForChatMessage(item.forwarded_from.file)"
                                                                    alt="" class="img-fluid">
                                                                <span
                                                                    class="msg_file_name">{{ getFileName(item.forwarded_from.file) }}</span>
                                                            </a>
                                                        </span>
                                                    </span>
                                                    <span class="chat_msg_content_show"
                                                        v-if="item.forwarded_from.message">
                                                        <span class="show_msg_of_reply_wrp"
                                                            v-if="item.forwarded_from.reply_to_msg"
                                                            :style="{ 'border-left-color': item.forwarded_from.sender.colour + '!important' }">
                                                            <span class="show_msg_of_reply_name"
                                                                :style="{ color: item.forwarded_from.sender.colour }">
                                                                {{ item.forwarded_from.sender.first_name }}
                                                                {{ item.forwarded_from.sender.last_name }}
                                                            </span>
                                                            <span class="show_msg_of_reply_txt"
                                                                v-if="item.forwarded_from.reply_to_msg.message"
                                                                v-html="item.forwarded_from.reply_to_msg.message">
                                                            </span>
                                                            <span class="show_msg_of_reply_txt" v-else>
                                                                <a :href="item.forwarded_from.reply_to_msg.file"
                                                                    target="_new">{{ item.forwarded_from.reply_to_msg.data.filename }}</a>
                                                            </span>
                                                        </span>
                                                        <span class="msg_link"
                                                            v-html="urlify(item.forwarded_from.message)"></span>
                                                    </span>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <span class="msg_in_file" v-if="item.file">
                                                    <span v-if="isImageFile(item.file)" class="msg_img_render_in_chat">
                                                        <a :href="item.file" target="_new"
                                                            @click="fileOpenNewTab(item.file)">
                                                            <img :src="item.file" alt="" class="img-fluid">
                                                        </a>
                                                    </span>
                                                    <span class="msg_file_render_in_chat" v-else>
                                                        <a :href="item.file" target="_new"
                                                            @click="fileOpenNewTab(item.file)">
                                                            <img :src="checkFileExtension(item.file)" alt=""
                                                                class="img-fluid">
                                                            <span class="msg_file_name">{{ getFileName(item.file)
                                                                }}</span>
                                                        </a>
                                                    </span>
                                                </span>
                                                <span class="chat_msg_content_show" v-if="item.message">
                                                    <span class="show_msg_of_reply_wrp" v-if="item.reply_to_msg"
                                                        :style="{ 'border-left-color': item.sender.colour + '!important' }">
                                                        <span class="show_msg_of_reply_name"
                                                            :style="{ color: item.sender.colour }">
                                                            {{ item.sender.first_name }}
                                                            {{ item.sender.last_name }}
                                                        </span>
                                                        <template v-if="item.reply_to_msg">
                                                            <template v-if="item.reply_to_msg.forwarded">
                                                                <span class="show_msg_of_reply_txt"
                                                                    v-if="item.reply_to_msg.forwarded_from.message"
                                                                    v-html="item.reply_to_msg.forwarded_from.message">
                                                                </span>
                                                                <span class="show_msg_of_reply_txt"
                                                                    v-else-if="item.reply_to_msg.forwarded_from.file">
                                                                    <a :href="item.reply_to_msg.forwarded_from.file"
                                                                        target="_new">{{
                                                                        getFileName(item.reply_to_msg.forwarded_from.file)
                                                                        }}</a>
                                                                </span>
                                                            </template>
                                                            <span class="show_msg_of_reply_txt"
                                                                v-else-if="item.reply_to_msg.message"
                                                                v-html="item.reply_to_msg.message">
                                                            </span>
                                                            <span class="show_msg_of_reply_txt" v-else>
                                                                <a :href="item.reply_to_msg.file" target="_new">{{
                                                                    getFileName(item.reply_to_msg.file) }}</a>
                                                            </span>
                                                        </template>
                                                    </span>
                                                    <span class="msg_link" v-html="urlify(item.message)"></span>
                                                </span>
                                            </template>
                                              <label class="message_indication_label"
                                                v-if="item.sender_info.id == selfUserId">
                                                <template v-if="item.is_read_by_staff">
                                                    <i class="msg_indicated_dot read" aria-hidden="true"></i>
                                                </template>
                                                <template v-else>
                                                    <i class="msg_indicated_dot unsent" aria-hidden="true"></i>
                                                </template>
                                            </label>
                                            <!-- <label class="message_indication_label"
                                                v-if="item.sender_info.id == selfUserId">
                                                <template
                                                    v-if="messagesIndicationStatusMethod(item.message_statuses) == 'read'">
                                                    <i class="msg_indicated_dot read" aria-hidden="true"></i>
                                                </template>
                                                <template
                                                    v-else-if="messagesIndicationStatusMethod(item.message_statuses) == 'delivered'">
                                                    <i class="msg_indicated_dot sent" aria-hidden="true"></i>
                                                </template>
                                                <template v-else>
                                                    <i class="msg_indicated_dot unsent" aria-hidden="true"></i>
                                                </template>
                                            </label> -->
                                            <!-- <div class="dropdown">
                                                <span class="msg_toggle_option" data-toggle="dropdown"><i
                                                        class="fa fa-chevron-down" aria-hidden="true"></i></span>
                                                <ul class="dropdown-menu">
                                                    <li v-on:click="replyMessageOnChatMethod(item)">
                                                        Reply</li>
                                                    <li @click="deteteMessageFromChatMethod(item.id, item.message, item.created_at, item.sender_info.id)"
                                                        v-if="item.sender_info.id == selfUserId">
                                                        Delete Message</li>
                                                </ul>
                                            </div> -->
                                        </template>
                                    </div>
                                    <time class="msg_time"><template v-if="item.sender_info.id != selfUserId">Lymphomap
                                            Admin,
                                        </template>{{ item.created_at | chattimeformat }}</time>
                                </li>
                            </ul>
                            <ul id="append_message"></ul>
                            <template v-if="typingUserInfoState">
                                <span v-if="typingUserInfoState.ChatRoomId == roomChatId" class="typing_info"> {{
                                    this.scrollToBottom() }} Lymphomap admin is
                                    typing... </span>
                            </template>
                        </div>
                        <!-- Messsage Details Here -->
                        <div class="msg_file_wrp" v-if="uploadFile">
                            <div class="msg_file_top_wrp">
                                <span class="msg_file_popup_close"><i class="fa fa-window-close" aria-hidden="true"
                                        @click="cancelUploadFile"></i></span>
                                <span class="uploaded_file_name">{{ filename }}</span>
                            </div>
                            <div class="uploaded_file_preview">
                                <img :src="imgSrc" alt="" class="img-fluid" v-if="imgSrc">
                                <img :src="checkFileExtension(filename)" alt="" class="img-fluid" v-else>
                            </div>
                        </div>
                        <!-- Messsage Details Here -->
                        <div class="message_action_box">
                            <div class="reply_msg_data_wrp" v-if="replyMessageData">
                                <div class="reply_msg_send_status">
                                    <div class="reply_msg_un">
                                        <span class="message_sender_name">{{ replyMessageData.sender.first_name }}
                                            {{ replyMessageData.sender.last_name }}</span>
                                    </div>
                                    <div class="reply_msg_txt">
                                        <template v-if="replyMessageData.forwarded">
                                            <span class="chat_msg_content_show"
                                                v-if="replyMessageData.forwarded_from.message"
                                                v-html="replyMessageData.forwarded_from.message">
                                            </span>
                                            <span class="show_msg_of_reply_txt"
                                                v-else-if="replyMessageData.forwarded_from.file">
                                                <a :href="replyMessageData.forwarded_from.file" target="_new">{{
                                                    getFileName(replyMessageData.forwarded_from.file) }}</a>
                                            </span>
                                        </template>
                                        <span class="chat_msg_content_show" v-else-if="replyMessageData.message"
                                            v-html="replyMessageData.message"></span>
                                        <span class="show_msg_of_reply_txt" v-else>
                                            <a :href="replyMessageData.file" target="_new">{{
                                                getFileName(replyMessageData.file) }}</a>
                                        </span>
                                    </div>
                                </div>
                                <span class="reply_msg_data_close">
                                    <img src="@/assets/images/close.png" class="img-fluid" width="14"
                                        v-on:click="cancelReplyMessageOnChatMethod">
                                </span>
                            </div>
                            <div class="message_action_box_tools">
                                <!-- <div class="file_uploader_box">
                                    <label for="fileUpload" class="file_uploader"><input type="file" id="fileUpload"
                                            name="fileUpload" @change="handleFileUpload" @click="onInputClick" hidden><i
                                            aria-hidden="true" title="attachment" class="fa fa-paperclip"></i></label>
                                </div> -->
                                <template v-if="uploadFile">
                                    <input class="message_init_field" placeholder="Send a message..." autocomplete="off"
                                        v-model="fileMessage">
                                    <button class="message_send_btn" id="file-message-submit"
                                        @click="fileMsgSubmitMethod">
                                        <div class="Icon" style="width: 18px; height: 18px;">
                                            <svg width="57px" height="54px" viewBox="1496 193 57 54" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                style="width: 18px; height: 18px;">
                                                <g id="Group-9-Copy-3" stroke="none" stroke-width="1" fill="none"
                                                    fill-rule="evenodd"
                                                    transform="translate(1523.000000, 220.000000) rotate(-270.000000) translate(-1523.000000, -220.000000) translate(1499.000000, 193.000000)">
                                                    <path
                                                        d="M5.42994667,44.5306122 L16.5955554,44.5306122 L21.049938,20.423658 C21.6518463,17.1661523 26.3121212,17.1441362 26.9447801,20.3958097 L31.6405465,44.5306122 L42.5313185,44.5306122 L23.9806326,7.0871633 L5.42994667,44.5306122 Z M22.0420732,48.0757124 C21.779222,49.4982538 20.5386331,50.5306122 19.0920112,50.5306122 L1.59009899,50.5306122 C-1.20169244,50.5306122 -2.87079654,47.7697069 -1.64625638,45.2980459 L20.8461928,-0.101616237 C22.1967178,-2.8275701 25.7710778,-2.81438868 27.1150723,-0.101616237 L49.6075215,45.2980459 C50.8414042,47.7885641 49.1422456,50.5306122 46.3613062,50.5306122 L29.1679835,50.5306122 C27.7320366,50.5306122 26.4974445,49.5130766 26.2232033,48.1035608 L24.0760553,37.0678766 L22.0420732,48.0757124 Z"
                                                        id="sendicon" fill="#ffffff" fill-rule="nonzero"></path>
                                                </g>
                                            </svg>
                                        </div>
                                    </button>
                                </template>
                                <template v-else>
                                    <input class="message_init_field" id="chat-message-input"
                                        placeholder="Send a message..." autocomplete="off"
                                        @paste="captureImgOnPasteMethod" v-model="textMessage">
                                    <button class="message_send_btn" id="chat-message-submit">
                                        <div class="Icon" style="width: 18px; height: 18px;">
                                            <svg width="57px" height="54px" viewBox="1496 193 57 54" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                style="width: 18px; height: 18px;">
                                                <g id="Group-9-Copy-3" stroke="none" stroke-width="1" fill="none"
                                                    fill-rule="evenodd"
                                                    transform="translate(1523.000000, 220.000000) rotate(-270.000000) translate(-1523.000000, -220.000000) translate(1499.000000, 193.000000)">
                                                    <path
                                                        d="M5.42994667,44.5306122 L16.5955554,44.5306122 L21.049938,20.423658 C21.6518463,17.1661523 26.3121212,17.1441362 26.9447801,20.3958097 L31.6405465,44.5306122 L42.5313185,44.5306122 L23.9806326,7.0871633 L5.42994667,44.5306122 Z M22.0420732,48.0757124 C21.779222,49.4982538 20.5386331,50.5306122 19.0920112,50.5306122 L1.59009899,50.5306122 C-1.20169244,50.5306122 -2.87079654,47.7697069 -1.64625638,45.2980459 L20.8461928,-0.101616237 C22.1967178,-2.8275701 25.7710778,-2.81438868 27.1150723,-0.101616237 L49.6075215,45.2980459 C50.8414042,47.7885641 49.1422456,50.5306122 46.3613062,50.5306122 L29.1679835,50.5306122 C27.7320366,50.5306122 26.4974445,49.5130766 26.2232033,48.1035608 L24.0760553,37.0678766 L22.0420732,48.0757124 Z"
                                                        id="sendicon" fill="#ffffff" fill-rule="nonzero"></path>
                                                </g>
                                            </svg>
                                        </div>
                                    </button>
                                </template>
                                <emoji-picker @emoji="insertEmojiMethod">
                                    <button class="emoji-invoker" slot="emoji-invoker"
                                        slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
                                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                            class="h-6 w-6 fill-current text-grey">
                                            <path d="M0 0h24v24H0z" fill="none" />
                                            <path
                                                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
                                        </svg>
                                    </button>
                                    <div slot="emoji-picker" slot-scope="{ emojis, insert }"
                                        class="emoji-picker-main-div">
                                        <div class="emoji-picker">
                                            <div>
                                                <div v-for="(emojiGroup, category) in emojis" :key="category"
                                                    :class="category == 'Frequently used' ? 'd-block' : 'd-none'">
                                                    <div class="emojis">
                                                        <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName"
                                                            @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </emoji-picker>
                            </div>
                        </div>
                    </div>
                    <div class="fixloader" v-if="apiLoader">
                        <div class="spinner spinner-1"></div>
                    </div>
                    <div class="fixloader" v-if="fileUploadLoader" style="z-index:999;">
                        <percentageLoader :uploadProgressState="uploadProgress" v-if="uploadProgress > 0 && submitted">
                        </percentageLoader>
                    </div>
                </div>
            </div>
        </div>
        <!-- Selected Message Delete Popup Code Here -->
        <msg-delete-popup v-if="deleteMsgPopupState" v-bind:deleteMessageDataOBJ="deleteMessageDataObj"
            :roomSocketUrl="chatSocket"></msg-delete-popup>
        <!-- Selected Message Delete Popup Code Here -->
    </div>
</template>

<script>
/* eslint-disable */

import EmojiPicker from 'vue-emoji-picker';
import Push from 'push.js';
import audioPlay from '@/assets/audio/piano.mp3';
import axios from 'axios';
import { bus } from '@/main';
import commonSocketConnectMethod from "@/commonSocket";
import fileExtension from '@/mixins/checkextension';
import { mapGetters } from 'vuex';
import moment from 'moment';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

let UploadMsgFileURL = root.uploadMsgFileUrl.link;
var pingInterval;
const $ = window.jQuery = require('jquery');
const msgDeletePopup = () => import('@/components/private/workspace/msg-delete-popup/');
const percentageLoader = () => import('@/components/common/percentage-loader-f-file/');


export default {
    name: 'user-chatbot',
    mixins: [fileExtension],
    components: {
        'msg-delete-popup': msgDeletePopup,
        percentageLoader,
        EmojiPicker
    },
    props: ['ticketInfo'],
    data() {
        return {
            apiLoader: false,
            roomChatId: '',
            socketForRoomId: '',
            userInfo: null,
            messagesList: [],
            typingUserInfoState: null,
            messageCount: 0,
            token: localStorage.getItem('token') || null,
            msgNextPageLoader: '',
            selfUserId: '',
            chatSocket: null,
            openSupportChatState: false,
            replyMessageData: null,
            deleteMsgPopupState: false,
            deleteMessageDataObj: {
                id: '',
                text: '',
                time: '',
                createdBy: '',
                roomId: '',
            },
            fileUploadLoader: false,
            uploadFile: null,
            filename: '',
            uploadProgress: 0,
            submitted: false,
            fileMessage: '',
            textMessage: '',
            imgSrc: '',
            messageIdForReply: '',
            selfUserInfo: null,
            emojis: ["👍", "👎", "😭", "😕", "😐", "😊", "😍",],
            typingTimeout: null,
            lastLiveMsgData: null
        };
    },
    computed: {
        ...mapGetters([
            'selfUserInfoGetters'
        ]),
        getSelfUserInfo() {
            this.selfUserInfo = this.$store.getters.selfUserInfoGetters.data;
            return;
        },
    },
    mounted() {
        this.selfUserId = localStorage.getItem('LoginedUserID');
        this.getSelfUserInfo;
        // this.handleMessageLoader();
        this.setupBusListeners();
        bus.$on('deleteMsgPopupStateBus', (data) => {
            this.deleteMsgPopupState = data;
        })
        // Assuming 'bus' is an existing event bus or custom event dispatcher
        bus.$on('MessageDeleteForChatOfAllNotification', (data) => {
            const chatMessageElement = document.getElementById('chatMessageId' + data.id);
            if (chatMessageElement) {
                const dropdown = chatMessageElement.querySelector('.dropdown');
                if (dropdown) {
                    dropdown.remove();
                }
                const replyWrapper = chatMessageElement.querySelector('.show_msg_of_reply_wrp');
                if (replyWrapper) {
                    replyWrapper.remove();
                }
                const label = chatMessageElement.querySelector('label');
                if (label) {
                    label.remove();
                }
                const chatMsgBoxWrp = chatMessageElement.querySelector('.chat_in_msg_box_wrp');
                if (chatMsgBoxWrp) {
                    chatMsgBoxWrp.classList.add('delete_msg_show_box');
                    const msgInFile = chatMessageElement.querySelector('.msg_in_file');
                    if (msgInFile) {
                        msgInFile.style.color = "#4c4c4c";
                        msgInFile.innerHTML = "<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted";
                    } else {
                        const anchorTag = chatMsgBoxWrp.querySelector('span');
                        anchorTag.style.color = "#4c4c4c";
                        anchorTag.innerHTML = "<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted";
                    }
                }
            }
        });
        this.chatRoomCreationMethod();
    },
    watch: {
        getSelfUserInfo() {
            return this.$store.getters.selfUserInfoGetters;
        },
    },
    methods: {
        insertEmojiMethod(emoji) {
            this.fileMessage += emoji;
            this.textMessage += emoji;
        },
        messagesIndicationStatusMethod(item) {
            if (!item) return;
            const allRead = item.every(status => status.is_read);
            const allDelivered = item.every(status => status.is_delivered);
            if (allRead) {
                return 'read';
            } else if (allDelivered) {
                return 'delivered';
            } else {
                return 'undelivered';
            }
        },
        setupBusListeners() {
            bus.$on('typingEventForChatBus', this.handleTypingEvent);
            bus.$on('selfUserUpdateStatus', this.handleSupportMessageCountNotification);
            bus.$on('updateMessageNotifications', this.handleLiveSchatCountNotification);
        },

        handleTypingEvent(data) {
            this.typingUserInfoState = data;
            if (data.message === 'stop') {
                this.typingUserInfoState = null;
            }
        },

        handleSupportMessageCountNotification(data) {
            this.messageCount = data.supportUnreadCount;
        },

        handleLiveSchatCountNotification(data) {
            if (data.supportUnreadCount > 0) {
                if (Push.Permission.has()) {
                    Push.create("Lymphomap Admin", {
                        body: data.message,
                        timeout: 4000,
                        onClick: function () {
                            window.focus();
                            this.close();
                        }
                    })
                    this.messageCount = data.supportUnreadCount;
                } else {
                    this.messageCount = data.supportUnreadCount;
                    this.playSound(audioPlay);
                }
            }
        },

        playSound(sound) {
            if (sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },

        handleMessageLoader() {
            const elmntList = document.getElementById("chatbot_scroll");
            if (!elmntList) return;

            elmntList.addEventListener("scroll", () => {
                if (elmntList.scrollTop === 0) {
                    if (this.msgNextPageLoader) {
                        axios.get(this.msgNextPageLoader)
                            .then((response) => {
                                if (response.status === 200 && response.data && response.data.data) {
                                    const { next, results } = response.data.data;
                                    const previousScrollHeight = elmntList.scrollHeight;

                                    this.msgNextPageLoader = next;
                                    this.messagesList = [...this.messagesList, ...results];

                                    this.$nextTick(() => {
                                        elmntList.scrollTop = elmntList.scrollHeight - previousScrollHeight;
                                    });
                                }
                            })
                            .catch((err) => {
                                console.error("Error loading older messages:", err);
                            });
                    }
                }
            });
        },

        async chatRoomCreationMethod() {

            try {
                this.openSupportChatState = true;
                // this.apiLoader = true;

                this.roomChatId = this.ticketInfo.id;
                this.socketForRoomId = this.ticketInfo.id.replace(/-/g, "");

                const messagesResponse = await this.$store.dispatch('botMessagesListAction', { id: this.ticketInfo.ticket_number });
                this.messagesList = messagesResponse.data.data.results;
                this.msgNextPageLoader = messagesResponse.data.data.next;
                this.messageCount = 0;
                this.apiLoader = false;
                // Also clear any pending typing timeout from the previous room
                if (this.typingTimeout) {
                    clearTimeout(this.typingTimeout);
                    this.typingTimeout = null;
                }
                this.$nextTick(() => {
                    this.scrollToBottom();
                });

                this.setupWebSocket();

            } catch (err) {
                console.error("Error in chat room creation or message loading:", err);
            }
        },

        setupWebSocket() {
            if (this.chatSocket) {
                this.chatSocket.close();
            }

            this.chatSocket = new WebSocket(
                `wss://${process.env.VUE_APP_WEBSOCKET_BASE_URL}/ws/ticket/${this.socketForRoomId}/?token=${this.token}`
            );
            const messageInput = document.querySelector('#chat-message-input');
            const messageSubmit = document.querySelector('#chat-message-submit');

            if (messageInput) {
                messageInput.focus();
                messageInput.onkeyup = (e) => {
                    if (e.keyCode === 13) {
                        messageSubmit.click();
                    } else {
                        // commonSocketConnectMethod.emit({
                        //     type: "TypingEventForChat",
                        //     message: 'typing',
                        //     ChatRoomId: this.roomChatId
                        // });
                        // clearTimeout(this.typingTimeout); // Clear previous timeout using component property
                        // this.typingTimeout = setTimeout(() => { // Assign to component property
                        //     commonSocketConnectMethod.emit({
                        //         type: "TypingEventForChat",
                        //         message: 'stop',
                        //         ChatRoomId: this.roomChatId
                        //     });
                        // }, 2000);
                    }
                };
            }

            if (messageSubmit) {
                messageSubmit.onclick = () => {
                    const message = messageInput.value.trim();
                    if (message.length > 0) {
                        const payload = {
                            chatRoomId: this.roomChatId,
                            message: message,
                            senderName: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
                        };
                        if (this.messageIdForReply) {
                            this.chatSocket.send(JSON.stringify({
                                type: 'chat_message',
                                message: {
                                    content: message,
                                    reply_to: this.messageIdForReply,
                                }
                            }));
                        } else {
                            this.chatSocket.send(JSON.stringify({
                                type: 'chat_message',
                                message: message
                            }));
                        }
                        messageInput.value = '';
                        // commonSocketConnectMethod.emit({
                        //     type: "TypingEventForChat",
                        //     message: 'stop',
                        //     ChatRoomId: this.roomChatId
                        // });
                        bus.$emit('newChatMessage', payload);
                        this.cancelReplyMessageOnChatMethod();
                    }
                };
            }

            this.chatSocket.onopen = () => {
                // console.log('Chat WebSocket opened for room:', chatRoomSocketId);
                pingInterval = setInterval(() => {
                    if (this.chatSocket.readyState === WebSocket.OPEN) {
                        this.chatSocket.send(JSON.stringify({ type: 'ping' })); // Send a ping message
                    }
                }, 30000);
            };
            this.chatSocket.onmessage = (e) => {
                this.renderLiveMessageMethod(e);
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            };

            this.chatSocket.onclose = (e) => {
                clearInterval(pingInterval);
                this.chatSocket = null;
            };

            this.chatSocket.onerror = (err) => {
                clearInterval(pingInterval);
                this.chatSocket = null;
            };
        },

        async messagesListAgainMethod() {
            const messagesResponse = await this.$store.dispatch('getUserSupportHelpChatDetailsByIdFun', { id: this.roomChatId });
            this.messagesList = messagesResponse.data.data.results;
            this.msgNextPageLoader = messagesResponse.data.data.next;
            const appendMessages = document.querySelector('#append_message');
            appendMessages.innerHTML = "";
            this.lastLiveMsgData = null;
        },
        renderLiveMessageMethod(e) {
            const data = JSON.parse(e.data);
            if(data.type == 'pong' || data.type == 'connection_established') {
                return;
            } else if (data.type == 'readStatus') {
                if (this.lastLiveMsgData) {
                    this.messagesListAgainMethod();
                }
                return;
            } else {
                let messagesList = document.getElementById('append_message');
                this.displayChatMessageMethod(data, messagesList);
            } // Ensure we only process chat messages
        },

        displayChatMessageMethod(data, messagesList) {
            const selfUserId = this.selfUserId; // Assuming 'this' context is correct
            const isSelf = data.sender_info.id === selfUserId;
            if (data.delete_for_everyone) {
                if (!isSelf) {
                    bus.$emit('MessageDeleteForChatOfAllNotification', data);
                }
                return;
            }; // Assuming 'this' context is correct
            const message = data.message;
            // const messageElement = document.createElement('div');
            // messageElement.classList.add('live_msg');

            const messageContentWrapper = document.createElement('li');
            messageContentWrapper.id = `chatMessageId${data.id}`;
            messageContentWrapper.classList.add(isSelf ? 'sent' : 'received');
            // messageElement.appendChild(messageContentWrapper);

            const chatMessageBox = document.createElement('div');
            chatMessageBox.classList.add('chat_in_msg_box_wrp');
            messageContentWrapper.appendChild(chatMessageBox);


            // Add Forwarded Label if applicable
            if (data.forwarded) {
                chatMessageBox.appendChild(this.createForwardedLabelMethod());
            }

            // Add Reply Feature if applicable
            if (data.reply_to_msg) {
                chatMessageBox.appendChild(this.createReplyInfoMethod(data)); // Assuming 'message' is accessible here
            }

            // Add Message Content (File, Link, or Text)
            chatMessageBox.appendChild(this.createMessageContentMethod(data));

            // Add Dropdown for Options
            // chatMessageBox.appendChild(this.createMessageOptionsDropdownMethod(data, this)); // Passing 'this' for context

            // Add Timestamp and Read Status
            const timeWrapper = document.createElement('span');
            timeWrapper.classList.add('msg_time_wrp');
            const timeElement = document.createElement('time');
            timeElement.classList.add('msg_time');
            if (data.sender_info.id === selfUserId) {
                timeElement.textContent = moment(data.created_at).locale('en').format('h:mm a');
            } else {
                timeElement.textContent = "Lymphomap Admin, " + moment(data.created_at).locale('en').format('h:mm a');
            }
            timeWrapper.appendChild(timeElement);
            messageContentWrapper.appendChild(timeElement);

            if (data.sender_info.id === selfUserId) {
                chatMessageBox.appendChild(this.createReadStatusLabelMethod(data));
            }

            messagesList.appendChild(messageContentWrapper);
            let appendMessages = document.getElementById('append_message');
            appendMessages.style.width = "100%";
            this.scrollToBottom();
        },

        createForwardedLabelMethod() {
            const forwardedMsgText = document.createElement("span");
            forwardedMsgText.classList.add('forwarded_msg_text');
            const shareIcon = document.createElement("i");
            shareIcon.classList.add('fa', 'fa-share');
            const forwardedMsgContent = document.createElement("span");
            forwardedMsgContent.textContent = 'Forwarded';
            forwardedMsgText.appendChild(shareIcon);
            shareIcon.after(forwardedMsgContent);
            return forwardedMsgText;
        },

        createReplyInfoMethod(replyData) {
            const showMsgOfReplyWrp = document.createElement("span");
            showMsgOfReplyWrp.classList.add('show_msg_of_reply_wrp');
            showMsgOfReplyWrp.style.borderLeftColor = replyData.sender.colour;

            const showMsgOfReplyName = document.createElement("span");
            showMsgOfReplyName.classList.add('show_msg_of_reply_name');
            showMsgOfReplyName.style.color = replyData.sender.colour;
            showMsgOfReplyName.textContent = `${replyData.sender.first_name} ${replyData.sender.last_name}`;

            let showMsgOfReplyTxt = document.createElement("span");
            showMsgOfReplyTxt.classList.add('show_msg_of_reply_txt');
            if (replyData.reply_to_msg.forwarded) {
                if (replyData.reply_to_msg.forwarded_from.file) {
                    const link = document.createElement('a');
                    link.href = replyData.reply_to_msg.forwarded_from.file;
                    link.target = '_new';
                    link.textContent = this.getFileName(replyData.reply_to_msg.forwarded_from.file);
                    showMsgOfReplyTxt.appendChild(link);
                } else {
                    showMsgOfReplyTxt.textContent = replyData.reply_to_msg.forwarded_from.message;
                }
            } else {
                if (replyData.reply_to_msg.file) {
                    const link = document.createElement('a');
                    link.href = replyData.reply_to_msg.file;
                    link.target = '_new';
                    link.textContent = this.getFileName(replyData.reply_to_msg.file);
                    showMsgOfReplyTxt.appendChild(link);
                } else {
                    showMsgOfReplyTxt.textContent = replyData.reply_to_msg.message;
                }
            }
            showMsgOfReplyWrp.appendChild(showMsgOfReplyName);
            showMsgOfReplyName.after(showMsgOfReplyTxt);
            return showMsgOfReplyWrp;
        },
        createMessageContentMethod(data) {
            const contentWrapper = document.createElement('span');
            // Helper function to create and append a link element
            const createLinkElement = (href, textContent) => {
                const link = document.createElement('a');
                link.href = href;
                link.target = '_new';
                link.classList.add('hyper_link');
                link.textContent = textContent;
                return link;
            };

            // Helper function to create and append a text span
            const createTextSpan = (message) => {
                const textSpan = document.createElement('span');
                textSpan.innerHTML = message;
                return textSpan;
            };

            // Helper function to handle file rendering
            const renderFile = (fileUrl, messageContent) => {
                const msgExt = fileUrl.substring(fileUrl.lastIndexOf('.') + 1).split('?')[0];
                const link = createLinkElement(fileUrl, ''); // Link text will be the image/file
                const fileIcon = document.createElement('img');
                fileIcon.classList.add('img-fluid');

                if (['png', 'PNG', 'jpeg', 'jpg', 'svg', 'gif', 'webp'].includes(msgExt)) {
                    fileIcon.src = fileUrl;
                    const imgContainer = document.createElement('span');
                    imgContainer.classList.add('msg_img_render_in_chat');
                    imgContainer.appendChild(link);
                    link.appendChild(fileIcon);
                    contentWrapper.appendChild(imgContainer);
                } else {
                    fileIcon.src = this.checkFileExtension(fileUrl);
                    const fileRenderContainer = document.createElement('span');
                    fileRenderContainer.classList.add('msg_file_render_in_chat');
                    fileRenderContainer.appendChild(link);
                    link.appendChild(fileIcon);

                    const fileNameSpan = document.createElement('span');
                    fileNameSpan.classList.add('msg_file_name');
                    fileNameSpan.textContent = fileUrl.split('/').pop().split('?')[0]; // Use pop() for last segment
                    link.appendChild(fileNameSpan); // Append fileNameSpan to the link
                    contentWrapper.appendChild(fileRenderContainer);
                }

                // Append message content after the file/image, if it exists
                if (messageContent) {
                    if (messageContent.startsWith('http://') || messageContent.startsWith('https://')) {
                        contentWrapper.appendChild(createLinkElement(messageContent, messageContent));
                    } else {
                        contentWrapper.appendChild(createTextSpan(messageContent));
                    }
                }
            };

            if (data.forwarded) {
                if (data.forwarded_from.file) {
                    renderFile(data.forwarded_from.file, data.forwarded_from.message);
                } else if (data.forwarded_from.message) { // Only message, no file
                    if (data.forwarded_from.message.startsWith('http://') || data.forwarded_from.message.startsWith('https://')) {
                        contentWrapper.appendChild(createLinkElement(data.forwarded_from.message, data.forwarded_from.message));
                    } else {
                        contentWrapper.appendChild(createTextSpan(data.forwarded_from.message));
                    }
                }
            } else if (data.file) {
                renderFile(data.file, data.message);
            } else if (data.message) { // Only message, no file and not forwarded
                if (data.message.startsWith('http://') || data.message.startsWith('https://')) {
                    contentWrapper.appendChild(createLinkElement(data.message, data.message));
                } else {
                    contentWrapper.appendChild(createTextSpan(data.message));
                }
            }

            return contentWrapper;
        },
        createMessageOptionsDropdownMethod(data, self) {
            const dropdownDiv = document.createElement("div");
            dropdownDiv.classList.add('dropdown');

            const msgToggleOption = document.createElement("span");
            msgToggleOption.classList.add('msg_toggle_option');
            msgToggleOption.setAttribute("data-toggle", 'dropdown');

            const faChevronDown = document.createElement("i");
            faChevronDown.classList.add('fa', 'fa-chevron-down');
            msgToggleOption.appendChild(faChevronDown);
            dropdownDiv.appendChild(msgToggleOption);

            const dropdownMenu = document.createElement("ul");
            dropdownMenu.classList.add('dropdown-menu');
            msgToggleOption.after(dropdownMenu);

            const replyLi = document.createElement("li");
            replyLi.textContent = 'Reply';
            replyLi.onclick = function () {
                self.replyMessageOnChatMethod(data);
            };
            dropdownMenu.appendChild(replyLi);
            if (data.sender_info.id === this.selfUserId) {
                const deleteLi = document.createElement("li");
                deleteLi.textContent = 'Delete Message';
                deleteLi.onclick = function () {
                    self.deteteMessageFromChatMethod(data.id, data.message, data.created_at, data.sender_info.id);
                };
                dropdownMenu.appendChild(deleteLi);
            }

            return dropdownDiv;
        },

        createReadStatusLabelMethod(data) {
            this.lastLiveMsgData = data;
            const labelReadS = document.createElement("label");
            labelReadS.classList.add('message_indication_label');
            const labelReadI = document.createElement("i");
            labelReadI.classList.add('msg_indicated_dot');
            const liveMsgs = document.querySelectorAll('#messages .msg_indicated_dot');
            const apiMsgs = document.querySelectorAll('#append_message .msg_indicated_dot');
            if (this.messagesIndicationStatusMethod(data.message_statuses) == 'read') {
                labelReadI.setAttribute("class", 'msg_indicated_dot read');
                // Iterate over each element and add a new class
                liveMsgs.forEach(element => {
                    element.classList.remove('sent');
                    element.classList.add('read'); // Replace 'your-new-class' with the class you want to add
                })
                apiMsgs.forEach(element => {
                    element.classList.remove('sent');
                    element.classList.add('read'); // Replace 'your-new-class' with the class you want to add
                })
            } else if (this.messagesIndicationStatusMethod(data.message_statuses) == 'delivered') {
                labelReadI.setAttribute("class", 'msg_indicated_dot sent');
                // Iterate over each element and add a new class
                liveMsgs.forEach(element => {
                    if (!element.classList.contains('read')) {
                        element.classList.remove('unsent');
                        element.classList.add('sent');
                    } // Replace 'your-new-class' with the class you want to add
                })
                apiMsgs.forEach(element => {
                    if (!element.classList.contains('read')) {
                        element.classList.remove('unsent');
                        element.classList.add('sent');
                    } // Replace 'your-new-class' with the class you want to add
                })
            } else {
                labelReadI.setAttribute("class", 'msg_indicated_dot unsent');
            }
            labelReadS.appendChild(labelReadI);
            return labelReadS;
        },

        handleSupportChatClosedMethod() {
            this.openSupportChatState = false;
            const appendMessages = document.querySelector('#append_message');
            if (appendMessages) {
                appendMessages.innerHTML = ""
            }
            this.cancelReplyMessageOnChatMethod();
            if (this.chatSocket) {
                this.chatSocket.close();
            }
            this.closePopupOfTicketMethod();
        },

        urlify(text) {
            var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
            return text.replace(urlRegex, function (url, b, c) {
                var url2 = (c == 'www.') ? 'http://' + url : url;
                return '<a href="' + url2 + '" target="_blank" class="hyper_link">' + url + '</a>';
            })
        },

        /*
         * This Will File Sent In Chat Method Here
         */
        onInputClick(event) {
            event.target.value = ''
        },

        handleFileUpload(event) {
            this.imgSrc = ''
            if (event.target.files && event.target.files.length > 0) {
                this.uploadFile = event.target.files[0];
                this.filename = this.uploadFile.name;
                if (event.target.files[0].type.split('/')[0] == 'image') {
                    if (typeof FileReader === 'function') {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                            this.imgSrc = event.target.result;
                        };
                        reader.readAsDataURL(this.uploadFile);
                    } else {
                        alert('Sorry, FileReader API not supported');
                    }
                }
            }
        },
        /*
         * This Methods Code End For Chat Room Specific
         */
        getURLObj() {
            return window.URL || window.webkitURL;
        },
        captureImgOnPasteMethod(e) {
            if (e.clipboardData && e.clipboardData.items) {
                var items = e.clipboardData.items;
                for (var i = 0; i < items.length; i++) {
                    if (items[i].type.indexOf('image') !== -1) {
                        var blob = items[i].getAsFile();
                        var URLObj = this.getURLObj();
                        var source = URLObj.createObjectURL(blob);
                        this.uploadFile = blob;
                        this.imgSrc = source;
                        this.filename = 'Photo';
                        e.preventDefault();
                    }
                }
            }
        },

        /*
         * This Will Check File Submitted In MSG Method Here
         */
        fileMsgSubmitMethod() {
            this.submitted = true
            let formData = new FormData();

            formData.append('chat_room_user', this.roomChatId);
            formData.append('message', this.fileMessage);
            formData.append('file', this.uploadFile);
            formData.append('filename', this.filename);

            this.fileUploadLoader = true;

            axios.post(UploadMsgFileURL, formData, {
                onUploadProgress: progressEvent => {
                    this.uploadProgress = Math.round(
                        (progressEvent.loaded / progressEvent.total) * 100
                    );
                },
            }).then((res) => {
                const messageId = res.data.data.id;
                this.chatSocket.send(JSON.stringify({
                    type: 'file_upload',
                    message_id: messageId
                }));
                const payload = {
                    chatRoomId: this.roomChatId
                };
                bus.$emit('newChatMessage', payload);
                this.cancelUploadFile();
            }).catch((err) => {
                toast.error(err.data.msg);
                this.fileUploadLoader = false;
                this.uploadProgress = 0;
                this.submitted = false;
            })
        },
        cancelUploadFile() {
            this.uploadFile = null;
            this.filename = '';
            this.fileMessage = '';
            this.fileUploadLoader = false;
            this.uploadProgress = 0;
            this.submitted = false;
        },

        fileOpenNewTab(href) {
            window.open(href, '_blank');
        },
        isImageFile(filePath) {
            const imageExtensions = ['png', 'jpeg', 'jpg', 'svg', 'gif', 'webp'];
            const fileExtension = filePath.split('.').pop().toLowerCase();
            let extension = fileExtension.substring(0, fileExtension.lastIndexOf("?"));
            return imageExtensions.includes(extension);
        },
        getFileName(filePath) {
            return filePath.split('/').pop().split('?')[0];
        },

        /*
         * This Will Delete Selected Message From Chat
        */
        deteteMessageFromChatMethod(messageId, MsgText, messageTime, createdBy) {
            this.deleteMessageDataObj.id = messageId;
            this.deleteMessageDataObj.time = messageTime;
            this.deleteMessageDataObj.text = MsgText;
            this.deleteMessageDataObj.createdBy = createdBy;
            this.deleteMessageDataObj.roomId = this.roomChatId;
            this.deleteMsgPopupState = true;
        },

        /*
         * This Will Reply Selected Message From Chat
        */
        replyMessageOnChatMethod(msgData) {
            this.replyMessageData = msgData;
            this.messageIdForReply = msgData.id;
            document.getElementById("chat-message-input").focus();
        },

        cancelReplyMessageOnChatMethod() {
            this.replyMessageData = null;
            this.messageIdForReply = "";
            this.textMessage = "";
            const messageSubmit = document.querySelector('#chat-message-input');
            if (messageSubmit) {
                messageSubmit.innerHTML = ""
            }
        },

        scrollToBottom() {
            const elmnt = document.getElementById("chatbot_scroll");
            if (elmnt) {
                const y = elmnt.scrollHeight;
                $('#chatbot_scroll').animate({ scrollTop: y }, 20);
            }
        },
        closePopupOfTicketMethod() {
            bus.$emit('botTicketsChatPopupBus', false);
            document.body.classList.remove('body_right_scroll_remove');
        }
    },
    beforeDestroy() {
        if (this.chatSocket) {
            clearInterval(pingInterval);
            this.chatSocket.close();
        }
        // document.getElementById("chatbot_scroll").removeEventListener("scroll", this.handleMessageLoader);
    },
};
</script>

<style lang="scss" scoped>
.support_chat {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;

    .chat_close_icon {
        cursor: pointer;
        color: #fff;
        font-size: 24px;
        position: absolute;
        right: 12px;
        z-index: 9;
        line-height: 1;

        .fa:hover {
            color: #fe4a3b;
        }
    }
    .s_chat_icon {
        color: #000000;
        font-size: 25px;
        text-align: center;
        line-height: 24px;
    }

    .support_box_inner {
        width: 100%;
    }

    @-webkit-keyframes appear {
        0% {
            opacity: 0;
            -webkit-transform: scale(0);
            transform: scale(0)
        }

        to {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1)
        }
    }

    @keyframes appear {
        0% {
            opacity: 0;
            -webkit-transform: scale(0);
            transform: scale(0)
        }

        to {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1)
        }
    }

    .chat_messenger_box {
        position: relative;
        height: 100%;
        width: 100%;
        min-width: 300px;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex
    }

    .chat_messenger_header {
        display: flex;
        align-items: center;
        padding-left: 10px;
        padding-right: 40px;
        height: 50px;
        flex-shrink: 0;
        border-radius: 10px 10px 0px 0px;

        h4 {
            opacity: 0;
            -webkit-animation: slidein .15s .3s;
            animation: slidein .15s .3s;
            -webkit-animation-fill-mode: forwards;
            animation-fill-mode: forwards
        }
    }

    .chat_messenger_prompt {
        margin: 0;
        font-size: 20px;
        color: #fffcc4;
    }

    @-webkit-keyframes slidein {
        0% {
            opacity: 0;
            -webkit-transform: translateX(10px);
            transform: translateX(10px)
        }

        to {
            opacity: 1;
            -webkit-transform: translateX(0);
            transform: translateX(0)
        }
    }

    @keyframes slidein {
        0% {
            opacity: 0;
            -webkit-transform: translateX(10px);
            transform: translateX(10px)
        }

        to {
            opacity: 1;
            -webkit-transform: translateX(0);
            transform: translateX(0)
        }
    }

    .chat_messenger_content {
        height: 450px;
        -webkit-box-flex: 1;
        -webkit-flex-grow: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .messenger_messages_box {
        position: relative;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 10px 20px;
        background-color: #111111;
        -webkit-overflow-scrolling: touch;
        color: #000000;
        margin: 0;
        display: flex;
        height: 100%;
        align-items: flex-end;
        flex-wrap: wrap;

        &::-webkit-scrollbar {
            width: 8px;
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #333333;
        }

        .messenger_messages_list {
            // display: -webkit-box;
            // display: -ms-flexbox;
            // display: flex;
            // -ms-flex-wrap: wrap;
            // flex-wrap: wrap;
            // -webkit-box-flex: 1;
            // -ms-flex-positive: 1;
            // flex-grow: 1;
            // -webkit-box-orient: vertical;
            // -webkit-box-direction: reverse;
            // -ms-flex-direction: column-reverse;
            // flex-direction: column-reverse;
            margin: 0px;
            width: 100%;

            li {
                width: 100%;
                float: left;
                clear: both;
            }
        }
    }

    .message_action_box {
        position: relative;
        width: 100%;
        -webkit-box-flex: 0;
        -webkit-flex-grow: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        -webkit-flex-shrink: 0;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        padding: 0px;
        color: #ffffff;
        background-color: #222222;
        border-radius: 0px 0px 10px 10px;

        .message_action_box_tools {
            display: flex;
            align-items: center;
        }

        .message_init_field {
              resize: none;
            border: none;
            outline: none;
            padding: 0 30px;
            background-color: transparent;
            font-size: 15px;
            line-height: 60px;
            color: #ffffff;
            height: 60px;
            width: calc(100% - 60px);

            &::-moz-placeholder {
                color: #9b9b9b;
            }

            &::-webkit-input-placeholder {
                color: #9b9b9b;
            }

            &::-ms-placeholder {
                color: #9b9b9b;
            }
        }

        .message_send_btn {
            position: absolute;
            bottom: 20px;
            width: 25px;
            height: 18px;
            padding: 0;
            border: none;
            outline: none;
            background-color: transparent;
            cursor: pointer;
            text-align: right;
            right: 0;

            &:hover .Icon {
                -webkit-transform: scale(1.1);
                -ms-transform: scale(1.1);
                transform: scale(1.1);
                -webkit-transition: all .1s ease-in-out;
                transition: all .1s ease-in-out;
            }

            &:hover .Icon path {
                fill: #87cefa;
            }
        }

        .file_uploader_box {
            width: 35px;
            text-align: center;

            .file_uploader {
                margin: 0;

                .fa {
                    font-size: 20px;
                    cursor: pointer;

                    &:hover {
                        color: #87cefa;
                        -webkit-transform: scale(1.1);
                        -ms-transform: scale(1.1);
                        transform: scale(1.1);
                        -webkit-transition: all .1s ease-in-out;
                        transition: all .1s ease-in-out;
                    }
                }
            }
        }

        .reply_msg_data_wrp {
            background: #232323;
            padding: 5px 10px;
            border-radius: 5px;
            border-left: 3px solid #87cefa;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .message_sender_name {
                color: #87cefa;
            }

            // .chat_msg_content_show {
            //     color: #87cefa;
            //     white-space: nowrap;
            //     text-overflow: ellipsis;
            //     overflow: hidden;
            //     display: block;
            //     margin: 0px;
            //     font-size: 14px;
            // }

            .reply_msg_data_close {
                img {
                    cursor: pointer;

                    &:hover {
                        color: #87cefa;
                        -webkit-transform: scale(1.1);
                        -ms-transform: scale(1.1);
                        transform: scale(1.1);
                        -webkit-transition: all .1s ease-in-out;
                        transition: all .1s ease-in-out;
                    }
                }
            }
        }


    }

    .typing_info {
        font-size: 14px;
        color: #00de09;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        display: block;
    }

    .spinner {
        width: 100px;
        height: 100px;

        &::before {
            width: 90px;
            height: 90px;
        }

        &::after {
            width: 55px;
            height: 55px;
        }
    }

    .msg_file_wrp {
        position: absolute;
        top: 40px;
        background: #0e0e0e;
        left: 0;
        right: 0;
        bottom: 40px;
        z-index: 999;

        .msg_file_top_wrp {
            background: lightskyblue;
            color: #000;
            padding: 5px 20px;
            display: flex;
            align-items: center;

            span {
                font-size: 14px;
                line-height: 1;
            }

            .msg_file_popup_close {
                cursor: pointer;
                margin-right: 8px;

                .fa {
                    font-size: 18px;
                    color: #000000;

                    &:hover {
                        color: #ff4338;
                    }
                }
            }
        }

        .uploaded_file_preview {
            width: 100%;
            height: 260px;
            margin: 40px auto 0px;
            text-align: center;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            padding: 0px 15px;

            .img-fluid {
                object-fit: cover;
                height: 100%;
                object-position: center center;
            }
        }
    }

    .emoji-invoker {
        position: absolute;
        top: 17px;
        right: 35px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        cursor: pointer;
        -webkit-transition: all 0.2s;
        transition: all 0.2s;
        padding: 0;
        background: transparent;
        border: 0;

        svg {
            fill: #545555;
            width: 25px;
            height: 25px;
        }

        &:hover {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);

            svg {
                fill: #ffc107;
            }
        }
    }

    .emoji-picker {
        position: absolute;
        z-index: 1000;
        font-family: 'Montserrat', sans-serif;
        border: 1px solid #2b2b2b;
        height: auto;
        overflow: auto;
        padding: 10px 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 50px;
        background: #1d2226;
        right: 0px;
        bottom: 40px;

        .emojis span {
            padding: 0 2px;
            cursor: pointer;
            border-radius: 2px;
            font-size: 18px;
        }
    }
}
</style>